import { createAsyncThunk, createSlice, isAnyOf } from '@reduxjs/toolkit';

import { errorNotification } from '../../components/notifications';
import api from '../../libs/api';

const initialState = {
  oldTransactions: {
    list: [],
    page: 1,
    query: { page: 1 },
    totalPages: 1,
    totalTransactions: 0,
  },
  oldTransaction: {},
  oldTransactionIds: [],
};

export const getOldTransactions = createAsyncThunk(
  'oldTransactions/getOldTransactions',
  async (query, { getState }) => {
    const currentQuery = getState().OldTransactions.oldTransactions.query;

    const effectiveQuery = query || currentQuery;

    const { data } = await api.get(
      '/old_accounts/oldtransactions',
      effectiveQuery,
    );

    return { data, query: effectiveQuery };
  },
);

export const getOldTransactionIds = createAsyncThunk(
  'oldTransactions/getOldTransactionIds',
  async () => {
    const { data } = await api.get('/old_accounts/oldtransactions/ids');

    return data;
  },
);

export const getOldTransaction = createAsyncThunk(
  'oldTransactions/getOldTransaction',
  async id => {
    const { data } = await api.get(`/old_accounts/oldtransactions/${id}`);

    return data;
  },
);

const oldTransactions = createSlice({
  name: 'oldTransactions',

  initialState,

  reducers: {
    clearOldTransactions: draft => {
      draft.oldTransactions = initialState.oldTransactions;
    },

    clearOldTransaction: draft => {
      draft.oldTransaction = initialState.oldTransaction;
    },

    clearOldTransactionIds: draft => {
      draft.oldTransactionIds = initialState.oldTransactionIds;
    },
  },

  extraReducers: builder => {
    builder.addCase(getOldTransactions.fulfilled, (draft, { payload }) => {
      draft.oldTransactions.list = payload.data.transactions;
      draft.oldTransactions.page = payload.data.page;
      draft.oldTransactions.query = payload.query;
      draft.oldTransactions.totalTransactions = payload.data.totalTransactions;
      draft.oldTransactions.totalPages = payload.data.totalPages;
    });

    builder.addCase(getOldTransaction.fulfilled, (draft, { payload }) => {
      draft.oldTransaction = payload;
    });

    builder.addCase(getOldTransactionIds.fulfilled, (draft, { payload }) => {
      draft.oldTransactionIds = payload;
    });

    builder.addMatcher(
      isAnyOf(
        getOldTransactions.rejected,
        getOldTransaction.rejected,
        getOldTransactionIds.rejected,
      ),
      (_Draft, { error }) => {
        errorNotification(error);
      },
    );
  },
});

export const {
  clearOldTransactions,
  clearOldTransaction,
  clearOldTransactionIds,
} = oldTransactions.actions;

export default oldTransactions.reducer;
